import { __, Alert, confirm } from 'modules/theme';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import APIManager from 'modules/common/apiManager';
import Select from 'react-select-plus';
import {
  ModalTrigger,
  Pagination,
  Button,
  ButtonCommonTheme,
  FormControl,
  Table,
  Label,
  DataWithLoader,
  FormGroup,
  ControlLabel,
  SelectFilterAPI
} from 'modules/theme';
import {
  ModalFooter,
  FormWrapper,
  FormColumn,
  ColumnTitle,
  InfoWrapper
} from 'modules/theme';

class QueueAddEdit extends Component {
  constructor(props) {
    super(props);
    this.moduleName = `Queue`;
    this.moduleUrl = `setting/queue`;
    this.saveData = this.saveData.bind(this);
    this.renderFormGroup = this.renderFormGroup.bind(this);
    this.mAPI = new APIManager();
    this.setData(this.props.editData);
  }
  setData(editData = '') {
    console.log('editData', editData);
    editData = editData || {};
    this.state = {
      name: editData.name || '',
      welcome: editData.welcome || '',
      queue: editData.queue || '',
      endCall: editData.endCall || '',
      waitTime: editData.waitTime || '',
      businessTime: [
        {
          startTime: editData.startTime || '',
          endTime: editData.endTime || ''
        }
      ],
      values: [],
      welcomeList: this.getDropData(editData.welcome_sound || []),
      queueList: this.getDropData(editData.queue_sound || []),
      endCallList: this.getDropData(editData.endCall_sound || []),
    };
  }

  getDropData(List) {
    let options = [];
    List = List || [];
    List.map(data => {
      options.push({
        value: data._id,
        label: data.name
      });
    });
    return options;
  }

  renderFormGroup(label, props) {
    return (
      <FormGroup>
        <ControlLabel required={props.required}>{label}</ControlLabel>
        <FormControl {...props} />
      </FormGroup>
    );
  }

  handleSelect(selectedOption, name) {
    this.setState({ [name]: selectedOption ? selectedOption.value : null });
  }

  addClick() {
    this.setState(prevState => ({ values: [...prevState.values, ''] }));
  }

  removeClick(i) {
    let values = [...this.state.values];
    values.splice(i, 1);
    this.setState({ values });
  }

  apiResponse(errorCode, data) {
    if (errorCode === 201) {
      // Alert.success(`${data.message}`);
      let message = data && data.message ? data.message : 'Successfully Done';
      Alert.success(`${message}`);
      this.resetAllData();
      this.props.closeModal(true);
    } else {
      // Alert.error(`${data.message}`);
      let message = data && data.message ? data.message : 'Something wrong happened';
      Alert.error(`${message}`);
    }
  }

  resetAllData() {
    this.setState({
      name: '',
      welcome: '',
      queue: '',
      endCall: '',
      waitTime: '',

    })
  }


  saveData(e) {
    console.log('startTime', this.state.businessTime);
    e.preventDefault();
    let _this = this;
    let Name = this.state.name || "";
    Name = Name.trim();
    let tData = {
      name: Name,
      welcome: this.state.welcome,
      queue: this.state.queue,
      endCall: this.state.endCall,
      waitTime: this.state.waitTime,
      businessTime: [
        // this.state.businessTime.push({ startTime: this.state.startTime, endTime: this.state.endTime })
        {
          startTime: this.state.startTime,
          endTime: this.state.endTime
        }
      ]
    };
    console.log('tData', tData);
    if (this.props.editData && this.props.editData._id) {
      this.mAPI.sendPostAPI(
        `${this.moduleUrl}/${this.props.editData._id}`,
        tData,
        data => {
          console.log(JSON.stringify(data, null, 2));
          if (data) {
            _this.resetAllData();
            _this.props.closeModal(true);
            Alert.success(`${this.moduleName} is Updated.`);
          }
        },
        (errorCode, data) => {
          this.apiResponse(errorCode, data);
        },
        'private',
        { id: tData._id },
        'PUT'
      );
    } else {
      this.mAPI.sendPostAPI(
        `${this.moduleUrl}`,
        tData,
        data => {
          _this.setData();
          _this.props.update();
          _this.props.closeModal(true);
          Alert.success(`${this.moduleName} is Created.`);
        },
        (errorCode, data) => {
          this.apiResponse(errorCode, data);
        }
      );
    }
  }

  generateParams(tData) {
    return tData.map(tData => ({
      value: tData._id,
      label: tData.name
    }));
  }

  renderWelcome() {
    return (
      <SelectFilterAPI
        dataUrl={"setting/sound"}
        selected={this.state.welcome || []}
        initialValues={this.state.welcomeList || []}
        label={""}
        name={""}
        multi={false}
        required={true}
        onSelect={(data) => {
          // console.log("data --", data);
          this.setState({ welcome: data })
        }}
      />
      // <Select
      //   placeholder=""
      //   onChange={item => {
      //     // console.log('Item',item);
      //     if (item) {
      //       this.setState({ welcome: item.value || '' });
      //     } else {
      //       this.setState({ welcome: '' });
      //     }
      //   }}
      //   value={this.state.welcome}
      //   options={this.generateParams(this.props.soundList)}
      // />
    );
  }

  renderQueue() {
    return (
      <SelectFilterAPI
        dataUrl={"setting/sound"}
        selected={this.state.queueList || []}
        initialValues={[]}
        label={""}
        name={""}
        multi={false}
        onSelect={(data) => {
          // console.log("data --", data);
          this.setState({ queue: data })
        }}
      />
      // <Select
      //   placeholder=""
      //   onChange={item => {
      //     // console.log('Item',item);
      //     if (item) {
      //       this.setState({ queue: item.value || '' });
      //     } else {
      //       this.setState({ queue: '' });
      //     }
      //   }}
      //   value={this.state.queue}
      //   options={this.generateParams(this.props.soundList)}
      // />
    );
  }

  renderEndCall() {
    return (
      <SelectFilterAPI
        dataUrl={"setting/sound"}
        selected={this.state.endCall || []}
        initialValues={this.state.endCallList || []}
        label={""}
        name={""}
        multi={false}
        onSelect={(data) => {
          // console.log("data --", data);
          this.setState({ endCall: data })
        }}
      />
      // <Select
      //   placeholder=""
      //   onChange={item => {
      //     // console.log('Item',item);
      //     if (item) {
      //       this.setState({ endCall: item.value || '' });
      //     } else {
      //       this.setState({ endCall: '' });
      //     }
      //   }}
      //   value={this.state.endCall}
      //   options={this.generateParams(this.props.soundList)}
      // />
    );
  }

  renderStartTime() {
    return (
      <FormGroup>
        <ControlLabel>Start Time</ControlLabel>
        <FormControl
          componentClass="timePicker"
          value={this.state.startTime || '00:01'}
          onChange={value => {
            const newTime = value.replace(/-/g, ':');
            const time = newTime.substr(0, 5);
            this.state.startTime = value;
            // this.state.businessTime.push({ startTime: '' })
          }}
        />
      </FormGroup>
    );
  }

  renderEndTime() {
    return (
      <FormGroup>
        <ControlLabel>End Time</ControlLabel>
        <FormControl
          componentClass="timePicker"
          value={this.state.endTime || '23:59'}
          onChange={value => {
            const newTime = value.replace(/-/g, ':');
            const time = newTime.substr(0, 5);
            this.state.endTime = value;
            // this.state.businessTime.push({ endTime: '' })
          }}
        />
      </FormGroup>
    );
  }

  createTime() {
    return this.state.values.map((el, i) => (
      <div key={i} style={{ display: 'flex', alignItems: 'center' }}>
        <FormWrapper>
          <FormColumn>{this.renderStartTime()}</FormColumn>
          <FormColumn>{this.renderEndTime()}</FormColumn>
        </FormWrapper>
        <Button
          btnStyle="link"
          size="small"
          onClick={this.removeClick.bind(this, i)}
          icon="cancel-1"
        />
      </div>
    ));
  }

  renderTime() {
    return (
      <ColumnTitle>
        <InfoWrapper style={{ marginBottom: '18px' }}>
          Calling Hours - Time
        </InfoWrapper>
        {this.createTime()}
        {/* {this.businessTime = this.state.businessTime.push({ startTime: this.state.startTime, endTime: this.state.endTime })} */}
        <Button
          onClick={this.addClick.bind(this)}
          btnStyle="default"
          size="small"
          icon="add"
        >
          Add
        </Button>
        {/* {this.state.businessTime.push({ endTime: '' })} */}
        {/* <input type='button' value='add more' onClick={this.addClick.bind(this)} /> */}
      </ColumnTitle>
    );
  }

  render() {
    const { modalType } = this.props;
    console.log('State Data', this.state);
    return (
      <form onSubmit={e => this.saveData(e)}>
        <FormWrapper>
          <FormColumn>
            {this.renderFormGroup('Name', {
              defaultValue: '',
              autoFocus: true,
              required: true,
              maxLength: 25,
              id: 'name',
              value: this.state.name,
              onChange: e => {
                if (e.target && e.target.value) {
                  this.setState({ name: e.target.value });
                } else {
                  this.setState({ name: "" });
                }
              }
            })}
          </FormColumn>
        </FormWrapper>
        <FormGroup>
          <ControlLabel required >Welcome</ControlLabel>
          {this.renderWelcome()}
        </FormGroup>
        <FormGroup>
          <ControlLabel required >Queue</ControlLabel>
          {this.renderQueue()}
        </FormGroup>
        <FormGroup>
          <ControlLabel required >End Call</ControlLabel>
          {this.renderEndCall()}
        </FormGroup>
        <FormWrapper>
          <FormColumn>
            {this.renderFormGroup('Wait Time', {
              defaultValue: '',
              type: 'number',
              min: '0',
              autoFocus: false,
              required: true,
              id: 'waitTime',
              value: this.state.waitTime,
              onChange: e => {
                this.setState({ waitTime: e.target.value });
              }
            })}
          </FormColumn>
        </FormWrapper>
        {this.renderTime()}
        <ModalFooter modalType={modalType}>
          <ButtonCommonTheme
            type='greyModalBtn'
            btnStyle="cancel"
            OnClick={() => this.props.closeModal()}
            size="xl"
          >
            Cancel
          </ButtonCommonTheme>
          <ButtonCommonTheme
            typee="blueModalBtn"
            type="submit"
            btnStyle="default"
            size="xl"
            style={{ float: 'right' }}
          >
            {this.props.editData && this.props.editData._id ? 'Update' : 'Add'}
          </ButtonCommonTheme>
        </ModalFooter>
      </form>
    );
  }
}

QueueAddEdit.propTypes = {
  group: PropTypes.array
};

QueueAddEdit.contextTypes = {
  __: PropTypes.func,
  closeModel: PropTypes.func.isRequired
};

export default QueueAddEdit;



// WEBPACK FOOTER //
// src/modules/screens/settings/Queue/components/QueueAddEdit.js